export default __webpack_public_path__ + "static/media/almostThere-mobile.995c848a.webp";